import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, ReferenceLine, BarChart, Bar,
  ReferenceDot, Tooltip, CartesianGrid, Legend, Brush, ErrorBar, AreaChart, Area, Rectangle,
  Label, LabelList } from 'recharts';
import styled from 'styled-components';


const ChartBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ccc;
  padding: 20px;
`;

const ChartBlockData = styled.div`
  display: flex;
  flex-direction: row;
`;

const ChartBlockTitle = styled.div`
  font-size: 21px;
  padding-left: 20px;
  max-width: 400px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: AvenirNext-DemiBold;
  text-align: center;
`;

const ChartBlockTitlePrimary = styled(ChartBlockTitle)`
  font-size: 25px;
`;

const ChartBlockTitleSecondary = styled(ChartBlockTitle)`
  font-size: 21px;
`;

const HighlightSubcopy = styled.div`
  font-family: AvenirNext-DemiBold;
  font-size: 18px;
`;

const HighlightValueSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const HighlightValue = styled.div`
  font-family: HelveticaNeue-Bold;
  font-size: ${ props => props.isPrimary ? '70px' : '35px'};
  padding-top: 0px;
  margin-top: -10px;
  color: black;
`;
const BoilerPlate = styled.div`
  background-color: #ddd;
  width: 400px;
  height: 300px;
`;


const CustomBar = (props) => {
  const { date, fill } = props;
  let newFill = fill;
  if (date === 'Target' || date == 'MTD') {
      newFill = 'blue';
  }
  return <Rectangle {...props} fill={newFill} className={`recharts-bar-rectangle ${date}`} />
};

const stackedColor = (idx) => {
  return ['red','orange','green','blue'][idx];
}

const FunnelChart = ({
  title,
  values,
  dateText,
  target,
  defaultColor,
  upperBound,
  excludeHighlight,
  isPrimary,
  isBoilerplate,
  isMulti,
  isStacked,
}) => {
  if(isBoilerplate)
  {
    return (<ChartBlock>
      {
        title && isPrimary && <ChartBlockTitlePrimary>{title} </ChartBlockTitlePrimary>
      }
      {
        title && !isPrimary && <ChartBlockTitleSecondary>{title} </ChartBlockTitleSecondary>
      }
      <BoilerPlate />
    </ChartBlock>
    );
  }
  let setUpperBound;
  if(isMulti){
    setUpperBound = target;
  } else {
    setUpperBound = Math.max.apply(null, (values.map(item => item.value)));
    if (target !== null) {
      setUpperBound = Math.max(target, setUpperBound);
    }
  }
  
  if( upperBound){
    setUpperBound = upperBound;
  }
  return (
    <ChartBlock>
      {
        title && isPrimary && <ChartBlockTitlePrimary>{title} </ChartBlockTitlePrimary>
      }
      {
        title && !isPrimary && <ChartBlockTitleSecondary>{title} </ChartBlockTitleSecondary>
      }
      {
        !excludeHighlight && <HighlightValueSection>
          <HighlightValue isPrimary={isPrimary}>{values[values.length - 1].value}</HighlightValue>
          <HighlightSubcopy >{dateText}</HighlightSubcopy>
        </HighlightValueSection>
      }
      <ChartBlockData>
        <BarChart
          width={400} height={250} data={values}
          margin={{ top: 10, right: 30, bottom: 20, left: 0 }}
        >
          <CartesianGrid vertical={false} />
          <XAxis dataKey="date" label="" interval={0} />
          <YAxis domain={[0, setUpperBound]} label="" />
          <Tooltip
            wrapperStyle={{
              borderColor: 'white',
              boxShadow: '2px 2px 3px 0px rgb(204, 204, 204)',
            }}
            contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
            labelStyle={{ fontWeight: 'bold', color: '#666666' }}
          />
          {
            !isMulti && <Bar shape={CustomBar}  dataKey="value" fill={defaultColor || (isPrimary ? "#dd7711" :"#dd9944")} isAnimationActive={false} />
          }
          {
            !!isMulti && Object.keys(values[0]).filter(key=> key != 'date').map((key,idx) => {
              return  <Bar shape={CustomBar}  stackId={isStacked ? "a" : idx} dataKey={key} fill={stackedColor(idx)} isAnimationActive={false} />
            })
          }
          {target && <ReferenceLine y={target} stroke="blue"></ReferenceLine>}
        </BarChart>
      </ChartBlockData>
    </ChartBlock>
  );
}

export default FunnelChart;